export default __webpack_public_path__ + "static/media/icon-cart-white.f5d452ae.svg";